import { render } from "./loyalty-lion-blog.vue?vue&type=template&id=349b279d"
import script from "./loyalty-lion-blog.vue?vue&type=script&lang=js"
export * from "./loyalty-lion-blog.vue?vue&type=script&lang=js"

import "./loyalty-lion-blog.vue?vue&type=style&index=0&id=349b279d&lang=scss"

import exportComponent from "/buddy/dormify/node_modules/@we-make-websites/basis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__